
    <section class="cmn-innerpage-wrapper leave-management">
        <div class="head">
            <div class="search-wrapper" >
                <input type="text" class="cmn-header-search" placeholder="Search" (input)="onSearch($event)"/>
            </div>
            <button class="cmn-filter-btn"  (click)="toggleDropdown($event)"
                [ngClass]="{ 'class-clicked': isDropdownOpen }">
                <img src="assets/images/icons/icon-filter.svg" alt="Filter Icon" />
            </button>

                <button class="cmn-add-btn"  (click)="navigateToApplyLeave()" *ngIf="canAddLeave$ | async">
                  <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> Apply Leave
                </button>
            </div>
            <!-- Filter Popup -->
        <!-- </div> -->
        <div class="inner-content" >
            <div class="common-noimage-tab-wrapper">
                <mat-tab-group animationDuration="0ms" (selectedTabChange)="onTabChange($event)">
                  <mat-tab>
                      <ng-template mat-tab-label>
                          <h2 class="leave-tab-title">All</h2>
                      </ng-template>
                      <div class="leave-history-table">
                          <app-all-leaves [searchQuery]="searchQuery" [filter]="filter" #allLeaves></app-all-leaves>
                      </div>
                  </mat-tab>

                    <!-- Mat Tab One -->
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <h2 class="leave-tab-title">Pending</h2>
                        </ng-template>
                        <div class="leave-history-table">
                            <app-pending [searchQuery]="searchQuery" [filter]="filter" *ngIf="activeTabIndex === 1" #pendingLeave></app-pending>
                        </div>


                    </mat-tab>
                    <!-- Mat Tab Two -->
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <h2 class="leave-tab-title">Approved</h2>
                        </ng-template>
                        <div class="leave-history-table">
                            <app-approved [searchQuery]="searchQuery" [filter]="filter"  *ngIf="activeTabIndex === 2" #approvedLeave></app-approved>
                        </div>
                    </mat-tab>
                    <!-- Mat Tab Three -->
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <h2 class="leave-tab-title">Rejected</h2>
                        </ng-template>
                        <div class="leave-history-table">
                            <app-rejected [searchQuery]="searchQuery" [filter]="filter"  *ngIf="activeTabIndex === 3" #rejectedLeave></app-rejected>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
           
        </div>
    </section>
